const DEFAULT_REFRESH_TIMEOUT_MS = 3000;

let refreshRequester = null;
let refreshInFlight = null;

export function registerUserDataRefreshRequester(requester) {
  refreshRequester = typeof requester === 'function' ? requester : null;

  return () => {
    if (refreshRequester === requester) {
      refreshRequester = null;
    }
  };
}

export function requestUserDataRefresh({ timeoutMs = DEFAULT_REFRESH_TIMEOUT_MS } = {}) {
  if (refreshInFlight) {
    return refreshInFlight.promise;
  }

  if (typeof refreshRequester !== 'function') {
    return Promise.reject(new Error('User data refresh requester is not registered'));
  }

  let timerId;
  let resolvePromise;
  let rejectPromise;

  const promise = new Promise((resolve, reject) => {
    resolvePromise = resolve;
    rejectPromise = reject;
  }).finally(() => {
    if (refreshInFlight?.timerId) {
      window.clearTimeout(refreshInFlight.timerId);
    }
    refreshInFlight = null;
  });

  timerId = window.setTimeout(() => {
    rejectUserDataRefresh(new Error('User data refresh timed out'));
  }, timeoutMs);

  refreshInFlight = {
    promise,
    resolve: resolvePromise,
    reject: rejectPromise,
    timerId,
  };

  try {
    refreshRequester();
  } catch (error) {
    rejectUserDataRefresh(error);
  }

  return promise;
}

export function resolveUserDataRefresh(payload) {
  if (!refreshInFlight) {
    return;
  }

  refreshInFlight.resolve(payload);
}

export function rejectUserDataRefresh(error = new Error('User data refresh failed')) {
  if (!refreshInFlight) {
    return;
  }

  refreshInFlight.reject(error);
}
